<template>
    <div class="history-route">
        <ElPopover
            v-model:visible="historyRouteStore.isOpen"
            width="300"
            placement="bottom"
            popper-class="history-route-popover"
            :teleported="false"
        >
            <template #reference>
                <div ref="referenceRef" class="history-route__reference" @mouseenter="openPopover" @mouseleave="scheduleClose">
                    <ElLink :underline="false" class="history-route--entry" @click="openPopover">
                        <i class="history-route-entry--icon iconfont icon-visit"></i>
                        <div class="title">最近访问</div>
                    </ElLink>
                </div>
            </template>
            <template #default>
                <div ref="popoverContentRef" class="history-route-list" @mouseenter="openPopover" @mouseleave="scheduleClose">
                    <div v-if="historyRoutes.length" class="history-route-items">
                        <div
                            v-for="item in historyRoutes"
                            :key="item.path"
                            class="history-route-item"
                            @click="handleRouteClick(item)"
                        >
                            <div class="history-route-item__meta">
                                <div class="history-route-item__title">{{ item.breadcrumb }}</div>
                            </div>
                            <i class="history-route-item__arrow iconfont icon-left"></i>
                        </div>
                    </div>
                    <div v-else class="history-route-empty empty-box">
                        <img :src="`${CDN_URL}/ghy-components/empty.png`" alt="暂无数据" />
                        <span class="empty-text">暂无数据</span>
                    </div>
                </div>
            </template>
        </ElPopover>
    </div>
</template>

<script setup lang="ts">
import { onBeforeUnmount, onMounted, ref } from "vue";
import { ElLink, ElPopover } from "element-plus";
import { useRouter } from "vue-router";
import { CDN_URL } from "@supplier/constants";
import { type HistoryRouteProps, useHistoryRouteStore } from "@/stores/historyRoute";

const router = useRouter();
const historyRouteStore = useHistoryRouteStore();
let historyRoutes = historyRouteStore.historyRouteList;

const referenceRef = ref<HTMLElement | null>(null);
const popoverContentRef = ref<HTMLElement | null>(null);
let closeTimer: ReturnType<typeof setTimeout> | undefined;

const openPopover = () => {
    if (closeTimer) clearTimeout(closeTimer);
    historyRoutes = historyRouteStore.historyRouteList;
    historyRouteStore.openPopover();
};

const scheduleClose = () => {
    if (closeTimer) clearTimeout(closeTimer);
    closeTimer = setTimeout(() => {
        historyRouteStore.closePopover();
    }, 120);
};

const handleOutsideClick = (event: MouseEvent) => {
    if (!historyRouteStore.isOpen) return;
    const target = event.target as Node;
    if (referenceRef.value?.contains(target) || popoverContentRef.value?.contains(target)) return;
    historyRouteStore.closePopover();
};

const handleRouteClick = (item: HistoryRouteProps) => {
    historyRouteStore.closePopover();
    router.push(item.path);
};

onMounted(() => {
    document.addEventListener("click", handleOutsideClick);
});

onBeforeUnmount(() => {
    document.removeEventListener("click", handleOutsideClick);
    if (closeTimer) clearTimeout(closeTimer);
});
</script>

<style scoped lang="scss">
@use "./index.scss";
</style>
